(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gc-billing-terms"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.gc-billing');
    roots.forEach((root) => {
      if (root.dataset.revealReady === 'true') return;
      root.dataset.revealReady = 'true';
      const items = root.querySelectorAll('.gc-reveal');
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        items.forEach((item) => item.classList.add('gc-is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('gc-is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -35px' });
      items.forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
